export const TEXT_STYLE =
  "mt-4 text-center text-sm text-stone-700 dark:text-stone-300 text-primary ";

export const START_NEW_NOTICE =
  "Due to high demand, no free trial is currently available. Please check again later.";

export const BUTTONS_TITLE = {
  usingVviinn: "My company is using vviinn",
  startNew: "Start Free Trial",
};
